import { render, staticRenderFns } from "./IntentSuggestionExamplesList.vue?vue&type=template&id=a8932880&"
import script from "./IntentSuggestionExamplesList.vue?vue&type=script&lang=js&"
export * from "./IntentSuggestionExamplesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports